import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonUtil } from '@libs/vc-core-lib';
import { MatIcon } from '@angular/material/icon';
import { IconComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-secure-edge-public-website',
    templateUrl: './secure-edge-public-website.component.html',
    styleUrls: ['./secure-edge-public-website.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, IconComponent],
})
export class SecureEdgePublicWebsiteComponent implements OnInit {
    private readonly route: ActivatedRoute = inject(ActivatedRoute);
    domain: string | undefined;

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            this.domain = params['domain'] || '';
            CommonUtil.hideAppLoader();
        });
    }
}
